module.exports = window["bonnet-webcomponent-react-cookie"];